<template>
  <v-app>
    <v-content>
      <v-container
        style="margin-top: 200px"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color=#FF3401
                dark
                flat
              >
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Email"
                    name="login"
                    type="text"
                    v-model="email"
                    color=#FF3401
                  />

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    v-model="password"
                    color=#FF3401
                    @keyup.enter="login()"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text color=#FF3401 @click="login()">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ error }}
    </v-snackbar>
  </v-app>
</template>

<script>

import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      snackbar: false,
      timeout: 1000,
      error: '',
    };
  },
  methods: {
    login() {
      const domain = this.email.replace(/.*@/, '');
      if (domain === 'bushelpowered.com' || domain === 'doosan.com') {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {
          localStorage.loggedIn = true;
          this.$router.push('/useractivity');
        }).catch((err) => {
          this.error = err.message;
          this.snackbar = true;
        });
      } else {
        this.error = 'Invalid Domain';
        this.snackbar = true;
      }
    },
  },
};
</script>
